import {v4 as uuid} from "uuid";
import type {Nominal} from "../types";
import type {
  AssetId,
  CategoryGroupEntryId,
  CategoryGroupId,
  CategoryId,
  GroupId,
  IngredientId,
  ItemId,
  ItemVariantId,
  RecipeId,
  ScheduledRecipeId,
  UnitId,
} from "./GroupRepo";
import type {UserId} from "./UserRepo";

export type DeviceId = Nominal<string, "deviceId">;

export const enum IdType {
  User = "user",
  Category = "cat",
  CategoryGroup = "catGrp",
  CategoryGroupEntry = "catGrpEntry",
  Group = "grp",
  Item = "item",
  ItemVariant = "itemVar",
  Recipe = "rcp",
  Ingredient = "ingrd",
  ScheduledRecipe = "schedRecipe",
  Asset = "_asset", // no prefix
  Unit = "unit",
}

type IdTypeToIdModel = {
  [IdType.User]: UserId;
  [IdType.Category]: CategoryId;
  [IdType.CategoryGroup]: CategoryGroupId;
  [IdType.CategoryGroupEntry]: CategoryGroupEntryId;
  [IdType.Group]: GroupId;
  [IdType.Item]: ItemId;
  [IdType.ItemVariant]: ItemVariantId;
  [IdType.Recipe]: RecipeId;
  [IdType.Ingredient]: IngredientId;
  [IdType.ScheduledRecipe]: ScheduledRecipeId;
  [IdType.Asset]: AssetId;
  [IdType.Unit]: UnitId;
};

const createId = <T extends IdType>(type: T): IdTypeToIdModel[T] => {
  if (type.startsWith("_")) return uuid() as IdTypeToIdModel[T];
  return `${type}:${uuid()}` as IdTypeToIdModel[T];
};

export default createId;
